import { useQuery } from "react-query";
import { getCameraSystems } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useCameraSystems = () => {
  const { data, isLoading, refetch } = useQuery(
    "GetCameraSystems",
    getCameraSystems,
    {
      refetchOnWindowFocus: false,
    }
  );

  return { data, isLoading, refetch };
};
